import React from "react";
// ANT DESIGN COMPONENTS
import { Alert } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

export interface OpcVendorPathFeedbackProps {
  /** Result of `opcVendorPathTransition` for the three bank-level path inputs. */
  transition: "ok" | "warn" | "block";
  /** Result of `composeOpcUaNodePreview`; `null` when no path would be composed. */
  preview: string | null;
}

/**
 * What the three OPC bank path inputs say about themselves: the node path that
 * will be composed from them, and, when they are only part filled, either the
 * rule that refuses the save or the two ways out of a state the bank already
 * had. Shared by the setup wizard's Banks step and the standalone bank form so
 * the two cannot word the same rule differently. Renders nothing when there is
 * nothing to say.
 */
export default function OpcVendorPathFeedback({ transition, preview }: OpcVendorPathFeedbackProps) {
  const [t] = useTranslation("global");

  if (preview === null && transition === "ok") return null;

  return (
    <div className="mt-2" data-testid="opc-vendor-path-feedback">
      {preview !== null && (
        <div data-testid="opc-vendor-path-preview">
          <span className="generalStyles__inputLabel">{t("general.bankOpcVendorPathPreview")}</span>{" "}
          <code>{preview}</code>
        </div>
      )}
      {transition === "block" && (
        <Alert
          type="error"
          showIcon
          message={t("general.bankOpcVendorPathPartialBlock")}
          style={{ marginTop: 8 }}
        />
      )}
      {transition === "warn" && (
        <Alert
          type="warning"
          showIcon
          message={t("general.bankOpcVendorPathPartialWarn")}
          style={{ marginTop: 8 }}
        />
      )}
    </div>
  );
}
